<template>
  <div id="location-pathfinders">
    <p class="notice">{{ notice }}</p>
    <carousel
      :perPageCustom="[[300, 2], [768, 3], [1024, 4]]"
      :paginationEnabled="false"
      :centerMode="true"
    >
      <slide
        v-for="pathfinder in locationPathfinders"
        :key="pathfinder.id"
      >
        <avatar :pathfinder="pathfinder"></avatar>
      </slide>
    </carousel>
  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import { Carousel, Slide } from "vue-carousel";
  import Avatar from "@/components/Pathfinder/Avatar.vue";

  export default {
    name: "LocationPathfinders",
    components: {
      Carousel,
      Slide,
      Avatar
    },
    data() {
      return {
        locationPathfinders: []
      };
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder
      }),
      notice() {
        return this.locationPathfinders.length > 0
          ? "OTHER PATHFINDERS IN THIS AREA"
          : "NO OTHER PATHFINDERS IN THIS AREA";
      }
    },
    methods: {
      ...mapActions(["loadLocationPathfinders"]),
      updateLocationPathfinders() {
        if (this.pathfinder.location) {
          this.loadLocationPathfinders(this.pathfinder.location).then(
            pathfinders => {
              this.locationPathfinders = pathfinders.filter(
                p => p.name !== this.pathfinder.name
              );
            }
          );
        }
      }
    },
    mounted() {
      this.updateLocationPathfinders();

      this.interval = setInterval(() => {
        this.updateLocationPathfinders();
      }, 60 * 1000);
    },
    beforeDestroy() {
      clearInterval(this.interval);
    }
  };
</script>

<style lang="scss">
  #location-pathfinders {
    .VueCarousel {
      padding: 0em;
      .VueCarousel-slide {
        padding: 1em;
      }
    }

    .notice {
      font-weight: bold;
      text-align: center;
    }
  }
</style>
